var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "related-recipes"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_setup.relatedRecipesTitle) + "\n  ")]), _vm._v(" "), _setup.shortenedDescription ? _c('p', {
    staticClass: "description"
  }, [_vm._v("\n    " + _vm._s(_setup.shortenedDescription) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "carousel"
  }, [_c(_setup.AzCarousel, _vm._l(_setup.recipes, function (recipe) {
    return _c(_setup.AzRecipeCard, {
      key: recipe.recipeId,
      staticClass: "item",
      attrs: {
        "type": recipe.type,
        "slug": recipe.slug,
        "title": recipe.title,
        "cover": recipe.cover,
        "category": recipe.category,
        "rating": recipe.rating,
        "num-reviews": recipe.numReviews,
        "wishlisted": recipe.wishlisted,
        "image-loading": "lazy"
      },
      on: {
        "click:wishlist": function clickWishlist($event) {
          return _setup.updateWishlist(recipe);
        },
        "click": function click($event) {
          return _setup.pushClickEvent(recipe);
        }
      }
    });
  }), 1)], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "background"
  }, [_c('span', {
    staticClass: "leaf-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "leaf-right"
  })]);
}];
export { render, staticRenderFns };